import { render, staticRenderFns } from "./batchOrder.vue?vue&type=template&id=6ed61a58&scoped=true&"
import script from "./batchOrder.vue?vue&type=script&lang=js&"
export * from "./batchOrder.vue?vue&type=script&lang=js&"
import style0 from "./batchOrder.vue?vue&type=style&index=0&id=6ed61a58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed61a58",
  null
  
)

export default component.exports